import { GlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/models";
import { RecentlyOpenedItemConfigurationProps, useResolveRecentlyOpenedItemForPersistence } from "./useResolveRecentlyOpenedItemForPersistence";
import { useCallback } from "react";
import { AppType } from "client/Api/Apps/common";
import { useAnalyticsStore } from "client/Features/Analytics/analyticsStore";
import { AnalyticsAppEventData } from "client/Api/Analytics/analytics";
import { useRecentlyOpenedResults } from "client/Features/Search/RecentSearch/Persistence/useRecentlyOpenedResults";
import { EmailClient, getEffectiveEmailClient } from "client_legacy/Email/emailClient";

export type EmailNavigationHandlerProps = {
	emailId: string;
}
	& RecentlyOpenedItemConfigurationProps;

export function useEmailNavigationHandler(props: EmailNavigationHandlerProps): (() => void) {
	const {
		emailId
	} = props;

	const addAnalyticsAppEvent: (data: AnalyticsAppEventData) => void = useAnalyticsStore(x => x.addAppEvent);
	const { registerFromRecentlyOpened: registerRecentlyOpenedItem } = useRecentlyOpenedResults();
	const recentlyOpenedItem: GlobalSearchItemPersistedModel = useResolveRecentlyOpenedItemForPersistence(props);

	return useCallback(
		(): void => {
			addAnalyticsAppEvent({ appType: AppType.Email });
			registerRecentlyOpenedItem(recentlyOpenedItem);
			navigateToEmail(emailId);
		},
		[
			addAnalyticsAppEvent,
			emailId,
			recentlyOpenedItem,
			registerRecentlyOpenedItem
		]
	);
}

export function navigateToEmail(emailId: string): void {
	const emailClient: EmailClient = getEffectiveEmailClient();
	if (emailClient.supportsNavigateToEmail) {
		emailClient.navigateToEmail({
			emailId: emailId
		});
	} else {
		console.error("Unable to navigate to e-mail because current client does not support navigation");
	}
}